export default __webpack_public_path__ + "static/media/d31379cf7cc332d5e32b935133e93ca7.png";